<div class="flex-column-center gap-flex-16 error-container">
    <mat-icon class="error-icon">
        {{ content().icon }}
    </mat-icon>
    <span class="text-2xl-700">
        {{ content().title }}
    </span>
    <span class="text-dark-sm-500">
        {{ content().message }}
    </span>
    <div class="flex-row gap-flex-8">
        <button class="default-border cancel-button" (click)="retry()">
            Retry
        </button>
        <button class="brand-button" (click)="relogin()">
            Sign in
        </button>
    </div>
</div>